import { getShortDate } from "../formatting"

  /**
 *
 * Returns ends on string ie 'in 1h' or 'on 12/12'
 */
   export const getTimeEndingString = (closeTime?: number) => {
    if(!closeTime) return ''
    let now = new Date()
    let currentTime = now.getTime() / 1000
    let diff = closeTime - currentTime
    let secondsInDay = 86400

    if(diff <= 0){
        //Close time is in past
        return 'past'
    }
    if(diff > 1209600){
        //Greater than 2 week, don't return anything
        return ''
    }
    if(diff > 604800){
        //Greater than 1 week
        return `on ${getShortDate(closeTime)}`
    }
    if(diff === 604800){
        //Greater than 1 week, don't return date
        return 'in 1 week'
    }
    if(diff >= 86400){
        //Between 1 day & 7 days
        let inDays = diff/secondsInDay
        let dayRounded = Math.round(inDays)
        return dayRounded === 1 ? 'in 1 day' : `in ${dayRounded} days` 
    }
    if(diff >= 3000){
        //Between 50 mins & 1 day
        let inHrs = diff/(60*60)
        let hrRounded = Math.round(inHrs)
        return hrRounded === 1 ? 'in 1 hr' : `in ${hrRounded} hrs` 
    }
    if(diff > 0){
        //Between ended & 50 mins
        return 'in less than 1 hr'
    }
    return ''
}